export default __webpack_public_path__ + "static/media/txt_lead.7ccccea1.svg";